import request from '@/utils/request'
import { indexExchangeRateInfo } from '@/utils/requestapis'
import { quoteNumber } from '@/utils/quoteDisplay'
import { getIndexQuotes, indexQuoteCode } from '@/utils/indexQuotes'

export { indexExchangeRateInfo as getIndexCatalog }
export async function indexRequest(action, data = {}, method = 'post') {
  const result = await request({ url: `vexe/v1/stockIndex/${action}`, method, ...(method === 'get' ? { params: data } : { data }) })
  // H5 buy/sell succeed with code 200 and data null, already unwrapped by request.
  if (result === null && (action === 'buy' || action === 'sell')) return result
  if (result === 0 || result == null) throw new Error('股指请求未成功，请重试')
  return result
}
export function indexRows(config = {}) {
  return Object.entries(config.mkt_index_data || {}).map(([key, item]) => ({ ...item, code: item.code || key }))
    .sort((a, b) => Number(a.id || 0) - Number(b.id || 0))
}
export function indexMarket(stock) {
  const code = String(stock.full_code || stock.code || '').toLowerCase()
  return code.includes('us') ? 'us' : code.includes('hk') ? 'hk' : 'cn'
}
export function indexQuoteClass(value) {
  const number = quoteNumber(value)
  return number > 0 ? 'rise' : number < 0 ? 'fall' : ''
}
export async function refreshIndexRows(rows, detailCode = '', canRefresh = () => true) {
  const keyOf = item => indexQuoteCode(item.full_code)
  const refreshableRows = rows.filter(canRefresh)
  const detailKey = /^us/.test(detailCode) ? 't_' + detailCode : /^hk/.test(detailCode) ? 'r_' + detailCode : detailCode.replace(/^(\d{6})\.(sh|sz|bj)$/i, '$2$1')
  // Selected index uses one full quote for both live price and metrics, not two snapshots.
  const keys = [...new Set(refreshableRows.map(item => item.full_code === detailCode ? detailKey : keyOf(item)).filter(key => key && key !== 's_'))]
  if (!keys.length) return rows
  const values = await getIndexQuotes(keys.join(','))
  return rows.map(item => {
    const value = values[item.full_code === detailCode ? detailKey : keyOf(item)]
    if (!Array.isArray(value) || !(quoteNumber(value[3]) > 0)) return item
    const full = value.length > 32
    const updated = { ...item, last_px: value[3] }
    for (const [field, index] of [['px_change', full ? 31 : 4], ['px_change_rate', full ? 32 : 5]]) {
      if (quoteNumber(value[index]) != null) updated[field] = value[index]
    }
    if (item.full_code === detailCode && Array.isArray(values[detailKey]) && quoteNumber(values[detailKey][3]) > 0) updated.quote_detail = values[detailKey]
    return updated
  })
}
export function indexEstimate(config, stock, account, hands) {
  const currency = (config.rate_index_info || {})[stock.code]
  const rate = quoteNumber(((config.rate_data || {})[currency] || {}).rate)
  const price = quoteNumber(stock.last_px)
  const lever = quoteNumber(config.lever)
  const commission = [stock.commission_point, config.user_commission_point, config.commission_point].map(quoteNumber).find(value => value != null)
  const balance = quoteNumber(account)
  if (!currency || !(rate > 0) || !(price > 0) || !(lever > 0) || commission == null || commission < 0 || balance == null) return null
  const available = balance / rate
  const amount = price * (quoteNumber(hands) || 0)
  const fee = Math.floor((amount * commission * lever + 1e-8) * 100) / 100
  return { currency, available, maximum: Math.floor((available / (price * (1 + commission * lever)) + 1e-8) * 10) / 10, amount, fee, total: amount + fee }
}
export function indexCloseAvailable(status, direction) {
  const enabled = direction === 1 ? status.sellLong : status.buyEmpty
  const count = quoteNumber(direction === 1 ? status.sellLongHnadNum : status.buyEmptyHandNum)
  return (enabled === true || Number(enabled) === 1) && count > 0 ? count : 0
}
export function indexRealizedProfit(order) {
  if (Number(order.entrust_order_type) !== 2 && Number(order.is_close) !== 1) return null
  return quoteNumber(order.sell_indexpl)
}
export function indexOrder(stock, mode, direction, type, price, hands, status = {}) {
  const quantity = quoteNumber(hands), limit = quoteNumber(price)
  if (!stock.code || !stock.full_code) throw new Error('请选择可交易股指')
  if (!['open', 'close'].includes(mode) || ![1, 2].includes(direction) || ![0, 1].includes(type)) throw new Error('交易参数异常')
  if (!(quantity >= 0.1) || Math.abs(quantity * 10 - Math.round(quantity * 10)) > 1e-8) throw new Error('数量最低0.1手，请输入0.1手的整数倍')
  if (!(limit > 0)) throw new Error('行情或委托价格无效，请重试')
  if (mode === 'close') {
    if (quantity > indexCloseAvailable(status, direction)) throw new Error('平仓数量超过可用持仓')
  }
  return { type, order_type: direction, price: limit, hand_num: quantity, index_code: stock.code }
}
export function indexTradeRoute(stock) {
  return { path: '/stocks', query: { market: 'index', symbol: stock.code, name: stock.prod_name || '' } }
}
